class @App.Components.VideoSearchSteps
  constructor: (el) ->
    @container = $('#video_search_steps')

    $(document).on 'App::Components::VideoSearch::search_ready', (e) =>
      @activate(0)

    $(document).on 'App::Components::VideoSearch::complete', (e) =>
      @activate(1)

    $(document).on 'App::Components::VideoGrid::show', (e) =>
      @activate(1)

    $(document).on 'App::Components::VideoPreview::show', (e) =>
      @activate(2)

  activate: (n) =>
    @deactivate_all()
    @container.find("li:eq(#{n})").addClass 'active'

  deactivate_all: =>
    @container.find('li.active').removeClass 'active'
